import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";

/**
 * `isPending` is optional so existing call sites keep working unchanged; when
 * provided, the buttons lock during the request. Without it the modal stayed
 * fully interactive while deleting, so a double click fired two DELETEs.
 */
const DeleteModal = ({ show, onDeleteClick, onCloseClick, isPending = false }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Confirmer la suppression</h4>
            <p className="text-muted mx-4 mb-0">
              Etes vous sur de supprimer cette donnée ?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
            disabled={isPending}
          >
           Annuler
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger "
            id="delete-record"
            onClick={onDeleteClick}
            disabled={isPending}
          >
            {isPending ? <Spinner size="sm" className="me-2" /> : null}
            Je confirme
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  isPending: PropTypes.bool,
};

export default DeleteModal;